'use client'

import LiveryCard from '@/components/_cards/livery/livery-card'
import ImageWithFallback from '@/components/common/image-with-fallback'
import { Skeleton } from '@/components/ui/skeleton'
import getUserName from '@/helpers/get-user-name'
import { urlSafeProfilePath } from '@/helpers/url-safe-profile-path'
import { getUserProfilePictureUrl } from '@/helpers/user'
import Link from 'next/link'
import { useEffect, useState } from 'react'

export default function LiveryOwnersOtherDesigns({
  ownersLiveryDesigns,
  livery,
  session,
}) {
  const [sortedFourDesigns, setSortedFourDesigns] = useState([])

  useEffect(() => {
    setSortedFourDesigns(
      ownersLiveryDesigns
        .filter((design) => design?.id !== livery.id)
        .sort(() => 0.5 - Math.random())
        .slice(0, 4),
    )
  }, [])
  return (
    <div className="bg-linear-to-b to-69% rounded-t-[16px] from-neutral-blue-800 to-neutral-blue-900 desktop-sm:rounded-t-[32px]">
      <div className="screen-grid">
        <div className="col-span-full mt-10 desktop-xs:mt-[93px]">
          <div className="flex flex-col items-center justify-between gap-2 desktop-xs:flex-row desktop-xs:gap-0">
            <h1 className="flex gap-2 text-h-4 desktop-xs:text-h-1">
              More liveries by
              <span className="hidden desktop-xs:block">
                {getUserName({ user: livery.user }, { profile: 'livery' })}
              </span>
            </h1>
            <div className="flex items-center gap-3">
              <div className="relative flex h-12 w-12 overflow-hidden rounded-full">
                <ImageWithFallback
                  src={getUserProfilePictureUrl(livery.user, {
                    profile: 'livery',
                  })}
                  id={livery.user.id}
                  fill
                />
              </div>
              <Link
                href={urlSafeProfilePath({
                  ...livery.user,
                  profileType: 'livery',
                })}
              >
                <h6 className="text-h-6 text-shades-0 underline underline-offset-2">
                  {getUserName({ user: livery.user }, { profile: 'livery' })}
                </h6>
              </Link>
            </div>
          </div>
          {sortedFourDesigns ? (
            <div className="mt-6 grid w-full grid-cols-1 gap-8 md:grid-cols-2 desktop-xs:mt-[60px] desktop-xs:grid-cols-4">
              {sortedFourDesigns.length > 0 &&
                sortedFourDesigns.map((design) => (
                  <LiveryCard
                    key={design.id}
                    livery={design}
                    session={session}
                  />
                ))}
            </div>
          ) : (
            <Skeleton className="mt-8 h-[330px] w-full grid-cols-1 gap-8 md:grid-cols-2 desktop-xs:mt-[60px] desktop-xs:grid-cols-4" />
          )}
        </div>
      </div>
    </div>
  )
}
